import { AxiosError } from 'axios';
import { ITaxParameter } from './types';
import { createSelector } from 'reselect';

export const initialSelectors = {
  selectIndexedProducts: () => ({}),
  selectProduct: () => null,
};

export const selectLoadedState = (state: { loaded: boolean }) => state.loaded;
export const selectTaxParameters = (state: { taxParameters: ITaxParameter[] }) =>
  state.taxParameters;
export const selectSyncError = (state: { error: AxiosError }) => state.error;
export const selectSyncState = (state: { syncing: boolean }) => state.syncing;
export const selectTaxParameterSyncState = (state: { taxParameterSyncing: boolean }) =>
  state.taxParameterSyncing;

export const selectIndexedTaxParameters = createSelector(selectTaxParameters, (taxParameters) =>
  taxParameters.reduce((indexed: { [x: string]: any }, taxParameter: ITaxParameter) => {
    if (taxParameter.id) {
      indexed[taxParameter.id] = taxParameter;
    }
    return indexed;
  }, {})
);
